import { forwardRef } from "react";
import { ButtonWrapper } from "./MuiButton.style";
import { ButtonProps } from "@mui/material/Button";
import IconButton, { IconButtonProps } from "@mui/material/IconButton";

interface MuiButtonProps extends ButtonProps {
  buttonType?: string;
  mode?: string;
}

export const MuiButton = forwardRef<HTMLButtonElement, MuiButtonProps>(
  (props, ref) => {
    const { buttonType = "", mode = "", className, id, ...rest } = props;
    return (
      <ButtonWrapper
        className={`mui-button ${className} ${mode} ${buttonType}`}
        ref={ref}
        data-testid={id}
        role="button"
        {...rest}
      />
    );
  },
);

export const MuiIconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  (props, ref) => {
    return <IconButton role="button" {...props} ref={ref} />;
  },
);

export const MuiButtonPrimary = forwardRef<HTMLButtonElement, MuiButtonProps>(
  (props, ref) => {
    return (
      <MuiButton
        role="button"
        {...props}
        ref={ref}
        buttonType={"btn-primary"}
      />
    );
  },
);

export const MuiButtonSecondary = forwardRef<HTMLButtonElement, MuiButtonProps>(
  (props, ref) => {
    return (
      <MuiButton
        role="button"
        {...props}
        ref={ref}
        buttonType={"btn-secondary"}
      />
    );
  },
);

export const MuiButtonTertiary = forwardRef<HTMLButtonElement, MuiButtonProps>(
  (props, ref) => {
    return (
      <MuiButton
        role="button"
        {...props}
        ref={ref}
        buttonType={"btn-tertiary"}
      />
    );
  },
);
